import FsLightbox from "fslightbox-react";

const Lightbox = ({ toggler, slide = 1, sources, ...rest }) => {
  return (
    <FsLightbox toggler={toggler} sources={sources} slide={slide} {...rest} />
  );
};

export default Lightbox;
